<template>
	<div
		class="square-box"
		:class="[assigned ? `square-box-${theme}` : 'square-box-disabled', { 'cursor-pointer': clickable }]"
		@click="handleClickItem">
		<img :src="logo" alt="logo" class="square-box-img">
		<div
			class="square-box-content tw-flex tw-justify-center tw-items-center"
			:class="[{ 'square-box-content-focused': focused && assigned }]"
		>
			<div>
				<check-icon class="check-icon" :color="checked || completed ? 'success' : ''"></check-icon>
			</div>
			<p v-if="focused && completed" class="content-name tw-m-0 tw-text-center">{{ quantity || 0 }} procesos</p>
			<div v-if="focused && completed" class="content-actions">
				<app-btn
					img="/static/img/paper-search.svg"
					text="Ver Importaciones"
					@click-icon.stop="$emit('onViewClick')"
				/>
				<app-btn
					img="/static/img/paper-plus.svg"
					text="Nuevo Proceso"
					@click-icon.stop="$emit('onAddClick')"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import CheckIcon from '@/modules/shared/components/icons/check-icon';
import PButton from '@/modules/shared/components/ui/p-button';

export default {
	name: 'square-box',
	components: { CheckIcon, PButton },
	methods: {
		handleClickItem() {
			if (this.assigned) {
				this.$emit('handle-click', 'assigned');
			} else {
				this.$emit('handle-click', 'no-assigned');
			}
		},
	},
	computed: {
	},
	props: {
		theme: {
			default: () => 'secondary',
		},
		logo: {
			default: () => '',
		},
		checked: {
			default: () => false,
		},
		completed: {
			default: () => false,
		},
		assigned: {
			default: () => false,
		},
		focused: {
			default: () => false,
		},
		quantity: {
			default: 0,
		},
	},
};
</script>

<style lang="scss" scoped>
.square-box {
	border-radius: 10px;
	box-shadow: 0 2px 10px 0 rgba(242, 242, 242, 0.5);
	background-color: #fff;
	padding-bottom: 90%;
	position: relative;
	user-select: none;
	&-img {
		position: absolute;
		top: 8px;
		left: 5px;
		height: 20px;
	}
	&.square-box-primary {
		border: solid 2px var(--app-color-primary);
	}
	&.square-box-secondary {
		border: solid 2px var(--app-color-secondary);
		.square-box-content {
			&.square-box-content-checked {
				.content-name {
					color: var(--app-color-info);
				}
			}
			&.square-box-content-focused {
				border: solid 2px var(--app-color-secondary);
				border-radius: 10px;
			}
			.content-name {
				color: var(--app-color-info);
			}
		}
	}
	&.square-box-disabled {
		border: solid 2px color(gray-medium);
	}
	&-focused,
	&-content {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}
	&-focused {
		z-index: 1;
		background-color: var(--app-color-primary);
		.content-name {
			color: #fff !important;
			font-size: size(large);
			padding: 0 10px;
			line-height: 16px;
		}
	}
	&-content {
		padding: 20px 10px;
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
		.content-name {
			color: var(--app-color-primary);
			font-size: size(medium);
			line-height: 14px;
		}
		.check-icon {
			position: absolute;
			top: 5px;
			right: 5px;
			width: 20px;
		}
		.check-active {
			position: absolute;
			top: -15px;
			left: 5px;
		}
		.content-actions {
			position: absolute;
			bottom: 5px;
			left: 0;
			right: 0;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/modules/recruitment/components/content/square-box.vue